import React from 'react';
import { Link, LinkProps, useLocation } from 'react-router-dom';

type ScrollToTopLinkProps = LinkProps & {
  children: React.ReactNode;
  scrollBehavior?: ScrollBehavior;
};

const ScrollToTopLink: React.FC<ScrollToTopLinkProps> = ({ 
  children, 
  to, 
  scrollBehavior = 'smooth',
  ...props 
}) => {
  const location = useLocation();
  const currentPath = location.pathname;
  
  // If we're already on the target page, just scroll to top
  // Otherwise, let the router handle the navigation
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    const targetPath = typeof to === 'string' ? to : to.pathname || '';
    
    if (currentPath === targetPath) {
      e.preventDefault();
      window.scrollTo({
        top: 0,
        behavior: scrollBehavior
      });
    } else {
      // Only scroll after navigation completes
      setTimeout(() => {
        window.scrollTo({
          top: 0,
          behavior: scrollBehavior
        });
      }, 100);
    }
  };

  return (
    <Link to={to} onClick={handleClick} {...props}>
      {children}
    </Link>
  );
};

export default ScrollToTopLink; 